$(document).ready(function() {
 		enableSliders();
      /**
 * 44px is the height of the Safari overflow bar
 */
const SAFARI_MOBILE_BOTTOM_MENU_HEIGHT = 44;

/**
 * Import from a library such as lodash or implement your own. Scroll events
 * should always be throttled or debounced.
 */
const throttle = () => {};

/**
 * When bottom > window.innerHeight, we know for a fact that `element` is
 * outside the window bounds. Normally, `position: fixed` keeps the element
 * inside the window bounds.
 *
 * @param {Element} element
 * @param {Number} offsetBottom - in pixels
 */
const reactToSafariOverflowBar = (element, offsetBottom) => {
  const {bottom} = element.getBoundingClientRect();
  if (Math.floor(bottom) > window.innerHeight) {
    element.style.bottom = offsetBottom + SAFARI_MOBILE_BOTTOM_MENU_HEIGHT;
  } else {
    element.style.bottom = offsetBottom;
  }
};

const offsetBottom = 20;
const stuckToBottom = document.querySelector('.is-stuckToBottom');

/**
 * Handle scroll events. This listener should be removed if the component
 * is removed, but this serves its demo purposes.
 */
window.addEventListener('scroll', throttle(() => reactToSafariOverflowBar(stuckToBottom, offsetBottom), 200));
})



document.addEventListener("shopify:section:load", function(){
  if (Shopify.designMode) {
    enableSliders()
  }
});




function enableSliders(){
  if (window.matchMedia("(max-width: 769px)").matches) {
    $('.press-slider').slick({
      dots: true,
      arrows: false
    });
  } 

  $('.autor-slider').slick({
    slidesToShow: 1,
    dots: true,
    nextArrow: '.nextArrow',
    prevArrow: '.prevArrow'
  })

  $('.slider-featured').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 6,
    nextArrow: '.nextBtnSlider',
    prevArrow: '.prevBtnSlider',
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 786,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  })

  $('.social-slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    nextArrow: '.BtnSliderNext',
    prevArrow: '.BtnSliderPrev',
     responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },       
      {
        breakpoint: 1250,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
       breakpoint: 750,
       settings: {
       slidesToShow: 1,
       slidesToScroll: 1
       }
      }
    ]
  })

  $('.promo-slides').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    prevArrow: false,
    nextArrow: false
  })
}

if (document.querySelectorAll(".prevBtnScroll").length > 0) {
  $(".prevBtnScroll").click(function () {
    $(this)
      .siblings(".category-content__featured-items")
      .stop()
      .animate({ scrollLeft: "-=200%" }, { duration: 75, easing: "linear" });
    return false;
  });
}

if (document.querySelectorAll(".nextBtnScroll").length > 0) {
  $(".nextBtnScroll").click(function () {
    $(this)
      .siblings(".category-content__featured-items")
      .stop()
      .animate({ scrollLeft: "+=200%" }, { duration: 75, easing: "linear" });
    return false;
  });
}